import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

const SsoIcon = ({ color = 'white' }: { color?: string }) => {
  return (
    <Svg viewBox="0 0 24 24" width="18" height="18">
      <Circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth="1.8" />
      <Path
        d="M9.35 10.2v-.85a2.65 2.65 0 1 1 5.3 0v.85"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.4 10.95h7.2c.69 0 1.25.56 1.25 1.25v3.4c0 .69-.56 1.25-1.25 1.25H8.4c-.69 0-1.25-.56-1.25-1.25v-3.4c0-.69.56-1.25 1.25-1.25Z"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <Path
        d="M12 13.15v1.5"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default SsoIcon;
